import React from "react";

function NoComments(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 101 88" {...props}>
      <g filter="url(#NoComments__filter0_dd)">
        <path fill="#fff" d="M80 2H6a2 2 0 00-2 2v20a2 2 0 002 2h74a2 2 0 002-2V4a2 2 0 00-2-2z"></path>
      </g>
      <path
        fill="#E4E4E4"
        d="M54.181 8.273H23.863v2.091h30.319v-2.09zM32 17h-8v2h8v-2zm11 0h-8v2h8v-2zm26.863-4.543h-46v3.136h46v-3.136z"></path>
      <rect width="10.45" height="10.45" x="8" y="6" fill="#005EE9" fillOpacity="0.3" rx="2"></rect>
      <g filter="url(#NoComments__filter1_dd)">
        <path fill="#fff" d="M80 58H6a2 2 0 00-2 2v20a2 2 0 002 2h74a2 2 0 002-2V60a2 2 0 00-2-2z"></path>
      </g>
      <path
        fill="#E4E4E4"
        d="M54.181 64.273H23.863v2.091h30.319v-2.09zM32 73h-8v2h8v-2zm11 0h-8v2h8v-2zm26.863-4.543h-46v3.136h46v-3.136z"></path>
      <rect width="10.45" height="10.45" x="8" y="62" fill="#005EE9" fillOpacity="0.3" rx="2"></rect>
      <g filter="url(#NoComments__filter2_dd)">
        <path fill="#fff" d="M95 30H21a2 2 0 00-2 2v20a2 2 0 002 2h74a2 2 0 002-2V32a2 2 0 00-2-2z"></path>
      </g>
      <path
        fill="#E4E4E4"
        d="M69.181 36.273H38.864v2.091h30.319v-2.09zM47 45h-8v2h8v-2zm11 0h-8v2h8v-2zm26.863-4.543h-46v3.136h46v-3.136z"></path>
      <rect width="10.45" height="10.45" x="23" y="34" fill="#F3D77D" rx="2"></rect>
      <defs>
        <filter
          id="NoComments__filter0_dd"
          width="86"
          height="32"
          x="0"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend>
        </filter>
        <filter
          id="NoComments__filter1_dd"
          width="86"
          height="32"
          x="0"
          y="56"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend>
        </filter>
        <filter
          id="NoComments__filter2_dd"
          width="86"
          height="32"
          x="15"
          y="28"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

export default NoComments;